export enum COUNTRY_TYPES {
    SUPPORTED_BY,
    SUPPORTED_BY_PARTNER,
    RECOMMENDED_DEALER,
    HEAD_OFFICE,
    SALES_PARTNER,
    SALES_SERVICE_PARTNER,
}

export interface CountrySelectorResponse {
    _id: string;
    countries: { [key: string]: ResponseCountry };
}

export interface ResponseCountry {
    code: string;
    name: string;
    supportedBy: string;
    recommendedDealer: Partner;
    languages: Language[];
    salesPartner: Partner;
    salesServicePartner: Partner;
    type: COUNTRY_TYPES;
}

export interface Language {
    code: string;
    name: string;
    url: string;
}

export interface Partner {
    address: string[];
    tel: string;
    fax: string;
    url: string;
    email: string;
}

export interface SupportedBy {
    code: string;
    country: string;
    languages: Language[];
}

export interface SupportedByPartner {
    code: string;
    country: string;
    address: string[];
}

export interface CountryAddress {
    address: string[];
}

export interface BaseCountry {
    code: string;
    name: string;
    languages?: Language[];
    address?: string[];
}

export interface SupportyByCountry extends BaseCountry {
    type: COUNTRY_TYPES.SUPPORTED_BY;
    data: SupportedBy;
}

export interface SupportyByPartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SUPPORTED_BY_PARTNER;
    data: SupportedByPartner;
}

export interface RecommendedDealerCountry extends BaseCountry {
    type: COUNTRY_TYPES.RECOMMENDED_DEALER;
    data: Partner;
}

export interface SalesPartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SALES_PARTNER;
    data: Partner;
}

export interface SalesServicePartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SALES_SERVICE_PARTNER;
    data: CountryAddress;
}

export interface HeadOfficeCountry extends BaseCountry {
    type: COUNTRY_TYPES.HEAD_OFFICE;
    languages?: Language[];
}

export type Country =
    | SupportyByCountry
    | SupportyByPartnerCountry
    | RecommendedDealerCountry
    | SalesPartnerCountry
    | SalesServicePartnerCountry
    | HeadOfficeCountry;
